import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ROUTE_PATH } from '@/routes';
import { IBreadcrumb } from '@/types';

interface IAuthState {
  breadcrumbs: IBreadcrumb[];
  activeMenu: string;
}

const initialState: IAuthState = {
  breadcrumbs: [],
  activeMenu: ROUTE_PATH.ACCOUNT,
};

const breadcrumbSlice = createSlice({
  name: 'breadcrumbs',
  initialState,
  reducers: {
    actionSetBreadcrumb: (state: IAuthState, action: PayloadAction<IAuthState>) => {
      const payload = action.payload;
      state.breadcrumbs = payload.breadcrumbs;
      state.activeMenu = payload.activeMenu;
    },
  },
});

export const { actionSetBreadcrumb } = breadcrumbSlice.actions;

export default breadcrumbSlice.reducer;
